import { useState } from 'react';
import { YStack } from 'tamagui';

import { TallSheet } from '../../components/sheet/TallSheet';
import { BodyMediumRegular } from '../../components/text/Typography';
import { ExpandingTile, ExpandingTilePreview } from '../../components/tiles';

export const Tiles = () => {
    const [isExpandingTileSheetOpen, setIsExpandingTileSheetOpen] =
        useState(false);
    const [
        isExpandingTilePreviewSheetOpen,
        setIsExpandingTilePreviewSheetOpen,
    ] = useState(false);

    return (
        <YStack gap={16}>
            <ExpandingTile
                title="Expanding Tile"
                numberIndicator="1"
                indicatorColor="$green300"
                onPress={() => {
                    setIsExpandingTileSheetOpen(true);
                }}
            />
            <ExpandingTilePreview
                eyebrow="Your Roadmap"
                title="Financial Freedom Plan"
                previewContent="Your blueprint to get you to where you want to be. This is your path to real progress with simple steps that your Guide will help you implement at every turn. Click to see the full plan and all the details about how we'll get you there."
                onPress={() => {
                    setIsExpandingTilePreviewSheetOpen(true);
                }}
            />
            <TallSheet
                isOpen={isExpandingTileSheetOpen}
                onClose={() => {
                    setIsExpandingTileSheetOpen(false);
                }}
                title="Complete Your Profile"
                showCloseButton={true}
            >
                <YStack gap={16}>
                    <BodyMediumRegular>
                        This tall sheet was opened from an ExpandingTile
                        component.
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        Add your information to get started with your financial
                        journey.
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua.
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        Ut enim ad minim veniam, quis nostrud exercitation
                        ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </BodyMediumRegular>
                </YStack>
            </TallSheet>
            <TallSheet
                isOpen={isExpandingTilePreviewSheetOpen}
                onClose={() => {
                    setIsExpandingTilePreviewSheetOpen(false);
                }}
                title="Financial Freedom Plan"
                showCloseButton={true}
            >
                <YStack gap={16}>
                    <BodyMediumRegular>
                        This tall sheet was opened from an ExpandingTilePreview
                        component.
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        Your blueprint to get you to where you want to be. This
                        is your path to real progress with simple steps that
                        your Guide will help you implement at every turn.
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        Here are the key steps in your financial freedom plan:
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        1. Build an emergency fund with 3-6 months of expenses
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        2. Pay off high-interest debt systematically
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        3. Maximize retirement contributions
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        4. Invest for long-term growth
                    </BodyMediumRegular>
                    <BodyMediumRegular>
                        5. Review and adjust quarterly with your Guide
                    </BodyMediumRegular>
                </YStack>
            </TallSheet>
        </YStack>
    );
};
